/** Max length for announcement titles (admin forms and API payloads). */
export const ANNOUNCEMENT_TITLE_MAX_LENGTH = 120;

/** Word limit for announcement description preview on the News & Calendar list. */
export const ANNOUNCEMENT_CARD_PREVIEW_MAX_WORDS = 40;

export function announcementId(item) {
  return item?.id ?? item?._id;
}

/**
 * Split description into a word-limited preview for list cards.
 * @returns {{ preview: string; isTruncated: boolean }}
 */
export function announcementDescriptionPreview(text, maxWords = ANNOUNCEMENT_CARD_PREVIEW_MAX_WORDS) {
  const s = typeof text === 'string' ? text.trim() : '';
  if (!s) return { preview: '', isTruncated: false };
  const words = s.split(/\s+/).filter(Boolean);
  if (words.length <= maxWords) return { preview: s, isTruncated: false };
  return { preview: words.slice(0, maxWords).join(' '), isTruncated: true };
}

/** Description text from API (primary: description; legacy fallbacks). */
export function announcementBody(item) {
  if (!item || typeof item !== 'object') return '';
  const t = item.description ?? item.content ?? item.message ?? item.body ?? '';
  return typeof t === 'string' ? t : '';
}

/**
 * API list/detail: announcement_date may be ISO datetime, e.g. "2026-04-17T00:00:00.000Z",
 * or a plain "YYYY-MM-DD". Returns calendar date for forms and display (local Y-M-D).
 */
export function extractAnnouncementDateOnly(raw) {
  if (raw == null || raw === '') return '';
  if (typeof raw === 'string') {
    const m = raw.match(/^(\d{4}-\d{2}-\d{2})/);
    if (m) return m[1];
    return '';
  }
  try {
    const d = new Date(raw);
    if (Number.isNaN(d.getTime())) return '';
    return d.toISOString().slice(0, 10);
  } catch {
    return '';
  }
}

/** Value for <input type="date" /> (YYYY-MM-DD). */
export function announcementDateInputValue(item) {
  return extractAnnouncementDateOnly(item?.announcement_date ?? item?.announcementDate);
}

export function formatAnnouncementDateShort(isoDate) {
  const v = extractAnnouncementDateOnly(isoDate);
  if (!v) return '—';
  const [y, m, d] = v.split('-').map((n) => parseInt(n, 10));
  const date = new Date(y, m - 1, d);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function todayLocalISODate() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
